import { forwardRef } from 'react';
import {
  type ChatInputHandle,
  ChatInput as SharedChatInput,
} from '@/features/ai-chat/ui/ChatInput';

type Props = {
  onSend: (message: string) => void;
  /** AI応答待ち中。入力は可能だが送信は不可 */
  waiting?: boolean;
  /** プレースホルダ（Welcome / Thread で文言を出し分けるため） */
  placeholder?: string;
};

/** 事業チャットの入力欄（共通 ChatInput の埋め込みレイアウトをそのまま利用） */
export const ChatInput = forwardRef<ChatInputHandle, Props>(
  ({ onSend, waiting = false, placeholder }, ref) => (
    <SharedChatInput ref={ref} onSend={onSend} waiting={waiting} placeholder={placeholder} />
  ),
);

ChatInput.displayName = 'ChatInput';
